export const productSizeOptions = [
  {
    label: 'SMALL',
    value: 'SMALL',
    desc: 'สินค้าขนาดเล็ก ส่งรวมกันได้',
  },
  {
    label: 'MEDIUM',
    value: 'MEDIUM',
    desc: 'สินค้าขนาดกลาง ส่งรวมได้ สูงสุด 4 ชิ้น ส่งรวมกับสินค้าขนาดเล็กได้',
  },
  {
    label: 'QUITE LARGE',
    value: 'QUITE LARGE',
    desc: 'สินค้าขนาดค่อนข้างใหญ่ ส่งแยกสูงสุด 2 ชิ้น',
  },
  {
    label: 'LARGE',
    value: 'LARGE',
    desc: 'สินค้าขนาดใหญ่ ส่ง 1 ชิ้น รวมกับสินค้าขนาดเล็กได้',
  },
  {
    label: 'SPECIAL',
    value: 'SPECIAL',
    desc: 'สินค้าพิเศษ ส่งแยกสูงสุด 1 ชิ้น',
  },
];

export const categoryOptions = [
  {
    label: 'Everyday treat & Goodies',
    value: 'Everyday treat & Goodies',
  },
  {
    label: 'Business Utility',
    value: 'Business Utility',
  },
  {
    label: 'Wellness & Vitality',
    value: 'Wellness & Vitality',
  },
  {
    label: 'Lifestyle & Thank You',
    value: 'Lifestyle & Thank You',
  },
  {
    label: 'Premium Reward',
    value: 'Premium Reward',
  },
  {
    label: 'Others',
    value: 'Others',
  },
];
